

$(document).on('click', '[data-multi-checkbox-select]', function() {
  const $this = $(this);
  const checkboxSelector = $this.attr('data-multi-checkbox-select');
  $(`input[name="${checkboxSelector}"]`).prop('checked', $this.is(':checked'));
});

$(document).on('click', '[data-multi-checkbox-select-choice]', function() {
  const $this = $(this);
  const name = $this.attr('name');
  const checkboxes = $(`input[name="${name}"]`);
  const checkedCheckboxes = $(`input[name="${name}"]:checked`);
  const selectAllCheckbox = $(`[data-multi-checkbox-select="${name}"]`);
  if (checkboxes.length === checkedCheckboxes.length) {
    selectAllCheckbox.prop('checked', true);
  } else {
    selectAllCheckbox.prop('checked', false);
  }
});
